import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    matriz: '',
    sector: '',
    sucursal: '',
    usuario: '',
    clave: '',
};

const mutations = {
    updateField,

    'INICIALIZAR'(state) {
        state.matriz = '';
        state.sector = '';
        state.sucursal = '';
        state.usuario = '';
        state.clave = '';
    },
    'SET_DATOS'(state, usuarioVeraz) {
        state.matriz = usuarioVeraz.matriz.trim();
        state.sector = usuarioVeraz.sector.trim();
        state.sucursal = usuarioVeraz.sucursal.trim();
        state.usuario = usuarioVeraz.usuario.trim();
        state.clave = usuarioVeraz.clave.trim();
    },
};

const getters = {
    getField,
};

const actions = {
    getUsuarioVeraz ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            apiAxios.get('usuarios-veraz') 
                .then(res => {
                    commit('SET_DATOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let usuarioVeraz= {
                matriz: state.matriz.trim(),
                sector: state.sector.trim(),
                sucursal: state.sucursal.trim(),
                usuario: state.usuario.trim(),
                clave: state.clave.trim()
            }
            
            let url = 'usuarios-veraz';
            apiAxios.post(url, usuarioVeraz)
                .then(response => resolve(response))
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}